import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { getAnnouncementByGuid, getActiveAnnouncements } from '../../api/announcementService';
import { format } from 'date-fns';
import { tr } from 'date-fns/locale';
import { FaCalendarAlt, FaBuilding, FaMapMarkerAlt, FaFileDownload } from 'react-icons/fa';

const AnnouncementDetail = () => {
  const { urlTag } = useParams();
  const location = useLocation();
  const guidFromState = location.state?.guid;
  const [announcement, setAnnouncement] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAnnouncementDetail = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      let guid = guidFromState;

      // Eğer state'den guid gelmemişse (direkt URL girişi), urlTag ile bul
      if (!guid && urlTag) {
        console.log('GUID not found in state, fetching by urlTag:', urlTag);
        const allAnnouncementsResponse = await getActiveAnnouncements(1, 1000);
        
        if (allAnnouncementsResponse.isSuccess && allAnnouncementsResponse.data?.items) {
          const foundAnnouncement = allAnnouncementsResponse.data.items.find(
            item => item.urlTag === urlTag
          );
          
          if (foundAnnouncement) {
            guid = foundAnnouncement.guid;
            console.log('Found announcement with guid:', guid);
          } else {
            console.log('Announcement not found with urlTag:', urlTag);
            setError('Duyuru bulunamadı');
            setLoading(false);
            return;
          }
        } else {
          console.log('Failed to fetch announcements list');
          setError('Duyurular yüklenirken bir hata oluştu');
          setLoading(false);
          return;
        }
      }

      if (!guid) {
        console.log('No guid available');
        setError('Duyuru bilgisi bulunamadı');
        setLoading(false);
        return;
      }

      console.log('Fetching announcement detail for guid:', guid);
      const response = await getAnnouncementByGuid(guid);
      console.log('Announcement detail response:', response);
      
      if (response.isSuccess && response.data) {
        setAnnouncement(response.data);
        setError(null);
      } else {
        setError(`Duyuru detayı yüklenirken bir hata oluştu: ${JSON.stringify(response)}`);
      }
    } catch (error) {
      console.error('Error in fetchAnnouncementDetail:', error);
      setError(`Duyuru detayı yüklenirken bir hata oluştu: ${error.response?.data?.message || error.message}`);
    } finally {
      setLoading(false);
    }
  }, [urlTag, guidFromState]);

  useEffect(() => {
    fetchAnnouncementDetail();
  }, [fetchAnnouncementDetail]);

  const formatDate = (dateString) => {
    try {
      return format(new Date(dateString), 'dd MMMM yyyy', { locale: tr });
    } catch (error) {
      return dateString;
    }
  };

  if (loading) {
    return (
      <div className="announcements-detail-page">
        <div className="container py-5">
          <div className="loading">Yükleniyor...</div>
        </div>
      </div>
    );
  }

  if (error || !announcement) {
    return (
      <div className="announcements-detail-page">
        <div className="container py-5">
          <div className="alert alert-danger">{error || 'Duyuru bulunamadı'}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="announcements-detail-page">
      <div className="container py-5">
        <div className="row">
          <div className="col-md-12">
            <div className="announcements-detail-card">
              <div className="detail-header">
                <h2>{announcement.header}</h2>
                
                <div className="detail-meta-grid">
                  <div className="meta-item">
                    <FaBuilding />
                    <span className="meta-label">Birim:</span>
                    <span>{announcement.department || 'Belirtilmemiş'}</span>
                  </div>
                  
                  <div className="meta-item">
                    <FaCalendarAlt />
                    <span className="meta-label">Tarih:</span>
                    <span>{formatDate(announcement.date)}</span>
                  </div>

                  {announcement.address && (
                    <div className="meta-item">
                      <FaMapMarkerAlt />
                      <span className="meta-label">Adres:</span>
                      <span>{announcement.address}</span>
                    </div>
                  )}
                </div>
              </div>

              <div className="detail-body-section">
                <h3>Duyuru Metni</h3>
                <div className="detail-text" dangerouslySetInnerHTML={{ __html: announcement.detail }} />
              </div>

              {announcement.fileUrl && (
                <div className="detail-action-section">
                  <a href={announcement.fileUrl} target="_blank" rel="noopener noreferrer" className="download-btn">
                    <FaFileDownload />
                    <span>Dokümanı İndir</span>
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementDetail;
